module.exports = __webpack_public_path__ + "assets/43fe275aea2b4a72fa91343b01ba66bf.png";